import React from 'react';
import { getUserMasterData } from '../../../selectors/selector';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import SearchPage from "../../pages/Search/search.page";

const SearchContainer: React.FC<any> = (props: any) => {
  const { location } = props;
  const segment = (location && location.state && location.state.segmenName) || 'New Search';
  return <SearchPage {...props} segmenName={segment} />;
};

const mapStateToProps = createStructuredSelector({
  userDetails: getUserMasterData()
});

export default connect(mapStateToProps, null)(SearchContainer);
